import { useLocale } from '@/contexts/LocaleContext';
import { NavLink, Outlet } from 'react-router-dom';
import { useHubTabs } from '@/lib/permisos';
import { MessageSquare, InboxIcon, Archive } from 'lucide-react';

// Sprint 58.1 (hotfix) — el sub-menú "Llamadas" (antes aquí, movido desde
// Config IA en S53.2) desapareció: una llamada que coincide con un contacto
// ahora es un canal más dentro de esa misma tarjeta en "Todas", con su
// transcripción — ya no necesita una pestaña propia y separada.
const inboxNavItems = [
  { to: '/tenant/inbox', icon: MessageSquare, labelKey: 'inbox.all', end: true, module: 'crm' },
  { to: '/tenant/inbox/open', icon: InboxIcon, labelKey: 'inbox.open', module: 'crm' },
  { to: '/tenant/inbox/closed', icon: Archive, labelKey: 'inbox.closed', module: 'crm' },
];

export default function InboxHubLayout() {
  const { tabs: visibleTabs } = useHubTabs(inboxNavItems);
  const { t } = useLocale();
  return (
    <div data-testid="inbox-hub-layout">
      <div className="flex items-center gap-3 mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-[#0F172A] tracking-tight">{t('nav.inbox')}</h1>
      </div>
      <div className="flex items-center gap-1 mb-6 border-b border-[#E2E8F0] pb-0">
        {visibleTabs.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={`inbox-nav-${(item.labelKey || item.label || 'x').toString().replace(/\./g, '-')}`}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-2.5 text-sm transition-all border-b-2 -mb-[1px] ${
                isActive
                  ? 'border-[#F72585] text-[#0F172A] font-medium'
                  : 'border-transparent text-[#64748B] hover:text-[#0F172A]'
              }`
            }
          >
            <item.icon className="w-4 h-4" strokeWidth={1.5} />
            <span>{item.labelKey ? t(item.labelKey) : item.label}</span>
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
